function useImageName(path) {
const regex = /\/static\/media\/(.+?)\.[a-f0-9]+\.webp$/i;
const match = path.match(regex);

let fileName = ""
if (match) 
  fileName = match[1];

return fileName;
}

export default useImageName;